import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 1a3.75 3.75 0 0 0-3.383 5.37C3.63 6.398 7 13 7 13l3.342-6.548A3.75 3.75 0 0 0 7 1Zm0 6a2.25 2.25 0 1 1 0-4.5A2.25 2.25 0 0 1 7 7Z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "google-maps"}) } }